export default __webpack_public_path__ + "static/media/car-retro-2.e591ab53.svg";